import noop from 'lodash/noop';
import React, {useCallback} from 'react';
import { createField } from '../helpers';
import { SelectValue, SelectProps } from '../types';

/**
 * Displays a field as a <select> element.
 */
const RadioField = createField<SelectValue, HTMLDivElement, SelectProps>(({
    className,
    name = null,
    options = null,
    value = null,
    onValueChange = noop,
    Renderer, label, error, onValueReset, onValueSubmit,
    ...props
}) => {
    return <div className={`forms-radio-field ${className}`} {...props}>
        {options.map(({label: subLabel, value: subValue}) =>
            <div className="radio" key={subValue}>
                <label>
                    <input type="radio"
                        name={name}
                        value={subValue}
                        checked={value === subValue}
                        onChange={(event) => {
                            onValueChange(subValue, value, name, event);
                        }}/>
                        {subLabel}
                </label>
            </div>
        )}
    </div>;
});

export default RadioField;
